<template>
  <v-dialog :value="value" scrollable :max-width="600" @input="$emit('input', $event)">
    <v-card v-if="isMounted">
      <v-card-title>
        <span class="title" :style="{ flex: 1 }">
          {{ $t('history') }}
        </span>
        <v-btn icon left @click="$emit('input', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-0">
        <slot />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMounted: false
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.isMounted = true
      } else {
        setTimeout(() => {
          this.isMounted = false
        }, 300)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/superrich/branch/HistoryDialog.vue